import React from "react";
import { QRCode } from "react-qrcode-logo";
import { Domain } from "../config/API";
const QRCodes = ({
  value,
  ecLevel = "L",
  size = 256,
  quietZone = 10,
  bgColor = "#FFFFFF",
  fgColor = "#000000",
  logoImage,
  logoWidth = 50,
  logoHeight = 50,
  logoOpacity = 1,
  qrStyle = "squares",
  eyeRadius = 0,
  removeQrCodeBehindLogo,
}) => {
  return (
    <QRCode
      enableCORS
      value={value}
      ecLevel={ecLevel}
      size={size}
      quietZone={quietZone}
      bgColor={bgColor}
      fgColor={fgColor}
      logoImage={`${Domain}/data/${logoImage}`}
      logoWidth={logoWidth}
      logoHeight={logoHeight}
      logoOpacity={logoOpacity}
      qrStyle={qrStyle}
      eyeRadius={eyeRadius}
      // removeQrCodeBehindLogo={removeQrCodeBehindLogo}
    />
  );
};

export default QRCodes;
